<template lang="pug">
  div.map-popup
    div(v-if="error")
      div.tooltip__head
        p.title Ошибка
        span(@click="close($event)").close.close--small.close--tooltip
      div.tooltip__body {{error}}
    div(v-else)
      div.tooltip__head
        div.tooltip__title.semibold {{head}}
        button.reset-btn.close.close--small.close--tooltip(@click="close")
      div.tooltip__body
        popup-fields-rows(:rows="rows" :model="fields" :excludedRows="excludedRows")
        button(
          v-if="fields.photo_id"
          @click="showPhoto = !showPhoto"
        ).reset-btn.button {{ !showPhoto ? 'Показать фото' : 'Скрыть фото' }}
        e-simple-file-uploader(
          v-show="showPhoto"
          name="photoPreview"
          tab-view="1"
          :model="fields"
          :read-only="true"
        )
      div.tooltip__footer.tooltip__foot(:class="{ 'tooltip__footer_space-between': isMsnPopup && objects && objects.length }")
        div(v-if="objects && objects.length" )
          div Схема потоков:
          div Отходы направляются на
          div(v-for="object in objects") {{object.name}}
        button.reset-btn.button.map-popup__msn-detail(v-if="isMsnPopup && !isGeoObjects" @click="getMsnDetail") Связанные источники образования отходов
      div.tooltip__footer.tooltip__foot
        button.reset-btn.button.button_no-border(v-if="showMore" @click.prevent="more") Подробнее
</template>

<script>
import baseMapPopupMixin from './base-map-popup-mixin.js'
import PopupFieldsRows from './popup-fields-rows'
import { map as mapEndpoint } from '@/api/api-endpoints'

/*
   active  - зеленый
   planned - желтый
*/
export default {
  name: 'map-popup-information-object',
  components: { PopupFieldsRows },
  mixins: [baseMapPopupMixin],
  props: {
    id: {
      type: Number,
      default: 0,
    },
    layerConfig: {
      type: Object,
      default: function () {
        return {
          endpoint: null,
        }
      },
    },
    subLayerConfig: {
      type: Object,
      default: function () {
        return {
          iconType: null,
        }
      },
    },
  },
  data() {
    return {
      downloadedFiles: {},
      showPhoto: false,
      objects: [],
      excludedRows: ['tko_object'],
    }
  },
  computed: {
    isMsnPopup() {
      const iconTypes = [
        'msn.modeling',
        'container',
        'mercury-lamp',
        'no-container',
        'separate',
        'recyclable-trash',
      ]
      return iconTypes.includes(this.subLayerConfig.iconType)
    },
    isGeoObjects() {
      return this.$sharedServices.router.history.current.name === 'geo.objects'
    },
  },
  methods: {
    injectConf(options) {
      let {
        id,
        layerConfig = {},
        model = {},
        subLayerConfig = {
          showMore: !this.$sharedServices.store.getters.isGuest,
        },
        closeCallback,
      } = options
      if (subLayerConfig.hasOwnProperty('showMore')) {
        this.showMore = subLayerConfig.showMore
      }
      this.showMore = !this.$sharedServices.store.getters.isGuest
      this.layerConfig = layerConfig || model.layerConfig
      this.subLayerConfig = subLayerConfig || model.subLayerConfig
      this.id = id || model.id
      this.closeCallback = closeCallback
      this.fetchData()
      this.registerVueInMap()
    },
    close() {
      this.$emit('close')
    },
    registerClosePopup() {},
    async fetchData() {
      if (
        this.id &&
        this.layerConfig &&
        this.subLayerConfig &&
        (this.subLayerConfig.endpoint || this.layerConfig.endpoint)
      ) {
        let usedEndpoint =
          this.subLayerConfig.endpoint || this.layerConfig.endpoint
        const query = {
          id: this.id,
        }
        if (this.isMsnPopup) {
          query.year = this.$sharedServices.router.history.current.query.year
        }
        let endpoint =
          typeof usedEndpoint === 'function'
            ? usedEndpoint(null, {
                query,
              })
            : usedEndpoint
        if (this.isMsnPopup) {
          endpoint = mapEndpoint.msnById(query)
        }
        if (this.layerConfig.menuClass === 'oth') {
          endpoint = mapEndpoint.sourceById(this.id)
        }
        await this.fetchGeoObjectPopupData(endpoint)
        if (this.isMsnPopup) {
          this.objects = this.fields.tko_object
        }
      } else {
        throw new Error('Wrong data')
      }
    },
    getMsnDetail() {
      this.$sharedServices.store.dispatch('msnDetailsOn', this.fields.id)
    },
  },
  mounted() {
    this.fetchData()
    this.registerVueInMap()
  },
}
</script>
<style lang="scss">
.map-popup {
  bottom: 20px;
  right: 20px;
  position: absolute;
  width: 315px;

  .tooltip__body,
  .tooltip__head,
  .tooltip__footer {
    background-color: white;
  }

  .tooltip__body {
    overlay-y: auto;
  }
  &__msn-detail {
    margin-top: 10px;
  }
  z-index: 10;
}
.leaflet-popup-tip-container {
}
</style>
